import { useQuery } from "@tanstack/react-query";
import { Navigate, Route, Routes } from "react-router-dom";
import { LoadingState } from "../../components/Ui";
import { getMe } from "../../lib/api";
import { AdminLayout } from "../../layouts/AdminLayout";
import { AdminOverview } from "./AdminOverview";
import { LandingEditor } from "./LandingEditor";
import { ProductEditor } from "./ProductEditor";
import { ProductList } from "./ProductList";
import { ResourceManager } from "./ResourceManager";
import { SettingsEditor } from "./SettingsEditor";
import { WeddingEditor } from "./WeddingEditor";

export function AdminApp() {
  const query = useQuery({ queryKey: ["admin-me"], queryFn: getMe, retry: false });
  if (!localStorage.getItem("steria_admin_token")) return <Navigate to="/admin/login" replace />;
  if (query.isLoading) return <LoadingState label="Opening workspace" />;
  if (query.isError || !query.data) return <Navigate to="/admin/login" replace />;

  return (
    <AdminLayout user={query.data}>
      <Routes>
        <Route index element={<AdminOverview user={query.data} />} />
        <Route path="landing-page" element={<LandingEditor />} />
        <Route path="wedding" element={<WeddingEditor />} />
        <Route path="products" element={<ProductList />} />
        <Route path="products/new" element={<ProductEditor />} />
        <Route path="products/:id/edit" element={<ProductEditor />} />
        <Route path="services" element={<ResourceManager resource="services" />} />
        <Route path="principles" element={<ResourceManager resource="principles" />} />
        <Route path="statistics" element={<ResourceManager resource="statistics" />} />
        <Route path="social-links" element={<ResourceManager resource="social-links" />} />
        <Route path="navigation" element={<ResourceManager resource="navigation" />} />
        <Route path="settings" element={<SettingsEditor />} />
        <Route path="*" element={<Navigate to="/admin" replace />} />
      </Routes>
    </AdminLayout>
  );
}
